import React, { Dispatch, SetStateAction } from 'react'

import { FirstStepsModalFactory } from '../../../main/factories'

import { useModalBox } from '../../contexts'

import {
  AssessmentsSvg,
  DolarIconSvg,
  QuestionMarkIconSvg,
  MyCustomersSvg
} from '../../assets/icons/svgComponents'
import AdminIcon from '../../assets/icons/svgComponents/admin-icon'

export type SidebarDataProps = {
  handleClick?: Dispatch<SetStateAction<boolean>>
  title: string
  path: string
  icon: React.ReactElement
  hasDropdown: { name?: string; onClick?: Dispatch<SetStateAction<boolean>> }[]
  cName: string
  allowed: string
}

export const SidebarData = (): SidebarDataProps[] => {
  const { modalBox } = useModalBox()
  const handleClick = () => {
    modalBox(<FirstStepsModalFactory />, 'Veja como gerar o laudo em 3 passos:')
  }

  return [
    {
      title: 'Meus pacientes',
      path: '/meus-pacientes',
      icon: <MyCustomersSvg />,
      hasDropdown: [],
      cName: 'nav-content',
      allowed: '2'
    },
    {
      title: 'Personalizar Textos',
      path: '',
      icon: <AssessmentsSvg />,
      hasDropdown: [
        { name: 'Documentos' },
        { name: 'Construtos' },
        { name: 'Testes' },
        { name: 'Fatores' }
      ],
      cName: 'nav-content dropdown',
      allowed: '2'
    },
    {
      title: 'Assinatura',
      path: '/minha-assinatura',
      hasDropdown: [],
      icon: <DolarIconSvg />,
      cName: 'nav-content dropdown',
      allowed: '2'
    },
    {
      title: 'Ajuda',
      path: '',
      hasDropdown: [
        { name: 'Primeiros passos' },
        { name: 'Ver instruçôes iniciais', onClick: handleClick }
      ],
      icon: <QuestionMarkIconSvg />,
      cName: 'nav-content dropdown',
      allowed: '2'
    },
    {
      title: 'Admin',
      path: '',
      icon: <AdminIcon />,
      hasDropdown: [
        { name: 'Cadastro de construto' },
        { name: 'Cadastro de teste' },
        { name: 'Relacionar teste x construto' },
        { name: 'Texto padrão - Documentos' },
        { name: 'Texto padrão - Construtos' },
        { name: 'Texto padrão - Testes ' },
        { name: 'Texto padrão - Fatores' }
      ],
      cName: 'nav-content dropdown',
      allowed: '1'
    }
  ]
}

export default SidebarData as () => SidebarDataProps[]
